// ReleaseNote11.0.js
import { Box, Typography } from "@mui/material";

const ReleaseNote11 = () => {
  return (
    <Box sx={{ backgroundColor: "#fff" }}>
      <Typography variant="h2" sx={{ mb: 2 }}>
        Release 11.0
      </Typography>

      <Typography variant="body2" sx={{ mb: 3 }}>
        Introducing the latest JUNE update with enhancements designed to improve
        flexibility and usability.
      </Typography>

      <Box sx={{ mb: 4 }}>
        <Typography variant="h5" sx={{ mb: 1 }}>
          <strong>Key Updates and Enhancements</strong>
        </Typography>

        <ul style={{ margin: 0, paddingLeft: "5%" }}>

          <li style={{ marginBottom: "16px" }}>
            <Typography variant="body2">
              <strong>Patent Image File Wrapper Downloader – Enhancement</strong>
            </Typography>
            <Typography variant="body2" sx={{ mt: 1 }}>
              The Patent Image File Wrapper Downloader now provides greater
              flexibility when downloading prosecution documents.
            </Typography>

            <Typography variant="body2" sx={{ mt: 2 }}>
              <strong>What's New</strong>
            </Typography>

            <ul style={{ margin: "8px 0 0 0", paddingLeft: "5%" }}>

              <li style={{ marginBottom: "12px" }}>
                <Typography variant="body2">
                  <strong>Dual Download Options:</strong> Users can now select
                  between:
                </Typography>
                <ul style={{ margin: "6px 0 0 0", paddingLeft: "5%" }}>
                  <li style={{ marginBottom: "6px" }}>
                    <Typography variant="body2">
                      <strong>Collated File</strong> – A single PDF containing
                      the complete prosecution history with bookmarks for easy
                      navigation.
                    </Typography>
                  </li>
                  <li>
                    <Typography variant="body2">
                      <strong>Individual Files</strong> – Each prosecution
                      document is downloaded as a separate file.
                    </Typography>
                  </li>
                </ul>
              </li>

              <li>
                <Typography variant="body2">
                  <strong>Descriptive File Naming:</strong> Individual files are
                  automatically named using the <strong>Application Number</strong>,{" "}
                  <strong>Mailing Date</strong>, and{" "}
                  <strong>Prosecution Event</strong>, making them easier to
                  identify, organize, and retrieve.
                </Typography>
              </li>

            </ul>
          </li>

        </ul>
      </Box>
    </Box>
  );
};

export default ReleaseNote11;
